import React from 'react';
import PropTypes from 'prop-types';
import './TestimonialCard.css';

const TestimonialCard = ({ name, review, rating }) => {
  const renderStars = () => {
    const stars = [];
    for (let i = 0; i < rating; i++) {
      stars.push(<span key={i} className="star">★</span>);
    }
    return stars;
  };

  return (
    <div className="testimonial-card">
      <h3>{name}</h3>
      <p>{review}</p>
      <div className="rating">{renderStars()}</div>
    </div>
  );
};

TestimonialCard.propTypes = {
  name: PropTypes.string.isRequired,
  review: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
};

export default TestimonialCard;